import React from "react";
import "./Header.css";

interface HeaderProps {
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  return (
    <header className="header">
      <button className="menu-button" onClick={onMenuClick}>
        ☰
      </button>
      <h1 className="header-title">News</h1>
    </header>
  );
};

export default Header;
